import type { VehicleWritable } from '@bambi/api-client/schemas';

import { defaultFormValues } from './defaultFormValues';
import type { FormValues } from './FormValues';

export function assignDefaultFormValues(
  vehicle: VehicleWritable | undefined
): FormValues {
  return {
    ...defaultFormValues,
    ...(vehicle || {}),
  };
}
